import AssignedCalls from "../superAdmin/AssignedCalls"

export const AssignedCallsToQL = () => {

    return (
        <>
            <AssignedCalls></AssignedCalls>
        </>
    )
}